<script setup>
import { ref } from "vue";
import LinkButton from "@/components/LinkButton.vue";

defineProps({
  colspan: { type: Number, required: true },
  label: { type: String, default: "Nuevo" },
  disabled: { type: Boolean, default: false },
});

defineEmits(["click"]);

const linkButtonRef = ref(null);

defineExpose({
  focus: () => linkButtonRef.value?.focus(),
});
</script>

<template>
  <tr>
    <td :colspan="colspan" class="text-center py-2">
      <link-button
        ref="linkButtonRef"
        :label="label"
        icon="fa-plus"
        :disabled="disabled"
        @click="$emit('click')"
      />
    </td>
  </tr>
</template>
